var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"parts"}},[_c('f7-navbar',{attrs:{"title":"Parts","back-link":"Back"}}),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"link":"/partsdaily/","title":"Daily Parts Sheet"}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"/partsadd/","title":"Add Parts"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }